import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useState } from 'react';
import { Col, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import PuzzleImg from '../../../assets/puzzle.svg';
import Button from '../../../components/Button';
import Link from '../../../components/Link';
import CustomSelect from '../../../components/Select';
import useModal from '../../../hooks/useModal';
import { ModalManagementStore } from '../../../providers/modal-manager';
import { PROFILE_ROUTE } from '../../../routes/types';
import { DateFormats, formatDate } from '../../../utils/utils';
import Successfull from './successful';
import SummaryModal from './summaryModal';

const CompletedPage = () => {
  const { openModal } = useContext(ModalManagementStore);
  const [showSummaryModal, handleShowSummaryModal, handleCloseSummaryModal] =
    useModal();
  const [successScreen, setSuccessScreen] = useState(false);

  const navigate = useNavigate();

  const options = [
    { value: '1', label: 'Completed' },
    { value: '2', label: 'Success' },
  ];

  const handleOnStateChange = (e: any) => {
    if (e === '1') {
      setSuccessScreen(false);
    } else if (e === '2') {
      setSuccessScreen(true);
    }
  };

  return (
    <Container>
      {!successScreen ? (
        <Container
          className={
            'cnd-custom-container-small mb-12 mt-12 px-0 px-xl-0 border-light-gray rounded-1'
          }
        >
          <div className="d-flex flex-column p-11">
            <section className="d-flex justify-content-center">
              <h5 className="m-0">Submitted, You are almost done</h5>
            </section>
            <section className="d-flex justify-content-center mt-7">
              <span className="text-sub1 fw-light lh-xs">
                You still have required actions below
              </span>
            </section>
            <section className="d-flex justify-content-center mt-7">
              <img src={PuzzleImg} alt="puzzle-img" />
            </section>
            <section className="d-flex flex-row justify-content-between mt-11">
              <div className="d-flex flex-column justify-content-center">
                <span className="text-sub1 fw-normal lh-xs">Submitted</span>
                <span className="text-sub1 fw-light lh-xs">
                  {formatDate(new Date(), DateFormats.MONTH_DAY_YEAR)}
                </span>
              </div>
              <div className="d-flex flex-column justify-content-center">
                <div className="d-flex justify-content-center">
                  <span className="text-sub1 fw-normal lh-xs"> Status</span>
                </div>
                <div>
                  <span className="text-light-salmon">
                    <FontAwesomeIcon icon={light('circle-info')} />
                  </span>
                  <span className="text-sub1 fw-light lh-xs"> Pending</span>
                </div>
              </div>
              <div className="d-flex flex-column justify-content-center ">
                <Link
                  href={`${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`}
                  target={'_blank'}
                >
                  <Button
                    variant="primary-outline"
                    className={'mx-lg-10 order-1 order-lg-3'}
                    size="sm"
                  >
                    Download/Print
                  </Button>
                </Link>
                <Button
                  variant="primary"
                  className={'mx-lg-10 order-1 order-lg-3 mt-3'}
                  size="sm"
                  onClick={handleShowSummaryModal}
                >
                  Show Summary
                </Button>
                <SummaryModal
                  show={showSummaryModal}
                  handleClose={handleCloseSummaryModal}
                />
              </div>
            </section>
          </div>
          <div className="d-flex flex-column p-11 border-top-light-gray">
            <section className="d-flex justify-content-start">
              <h5 className="m-0">Next Steps</h5>
            </section>
            <section className="d-flex justify-content-start mt-7">
              <span className="fw-normal text-sub1 lh-xs">
                Awaiting confirmation
              </span>
            </section>
            <section className="d-flex justify-content-start mt-7">
              <span className="fw-light text-sub1 lh-xs">
                Your documentation will be reviewed and processed within the
                next 3 - 5 business days. Visit the Family Members section of
                the profile page.
              </span>
            </section>
            <section className="d-flex justify-content-start mt-7">
              <Button
                leftIcon={light('family')}
                variant="primary-outline"
                className={'order-1 order-lg-3'}
                onClick={() =>
                  navigate(`${PROFILE_ROUTE.slice(0, 9)}familymembers`)
                }
              >
                Family Members
              </Button>
            </section>
          </div>
          <div className="d-flex flex-column p-11 bg-white solid-salmon-border rounded-border-bottom">
            <section className="d-flex justify-content-start">
              <h5 className="m-0">Action Required</h5>
            </section>
            <section className="d-flex justify-content-start mt-7">
              <span className="fw-light text-sub1 lh-xs">
                In order to complete the verification you must send in the
                required documentation
              </span>
            </section>
            <section className="d-flex justify-content-between mt-7">
              <span className="fw-normal text-sub1 lh-xs d-flex align-items-center">
                STEP 1 - Download/Print Forms
              </span>
              <Button
                leftIcon={light('print')}
                variant="danger"
                className={'order-1 order-lg-3'}
                size="sm"
                href={`${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`}
                target={'_blank'}
              >
                Print Cover Sheet
              </Button>
            </section>
            <section className="d-flex justify-content-start mt-7">
              <span className="fw-normal text-sub1 lh-xs">
                STEP 2 - Gather required documention
              </span>
            </section>
            <section className="d-flex flex-column justify-content-start mt-7">
              <span className="fw-normal text-sub1 lh-xs">
                STEP 3 - Mail/Fax
              </span>
              <span className="fw-light text-sub1 lh-xs">
                Include the cover sheets as your first page with the required
                documentation in step 2.
              </span>
              <span className="fw-light text-sub1 lh-xs">
                You can choose to upload or mail, If mailing do not staple.
              </span>
            </section>
            <section className="d-lg-flex flex-lg-row flex-sm-column">
              <div className="d-flex flex-column border-separator px-12 py-10 w-100">
                <div className="d-flex justify-content-center justify-content-lg-start">
                  <span className="fw-normal text-sub1 lh-xs">
                    Scan and Upload
                  </span>
                </div>
                <div className="d-flex justify-content-center justify-content-lg-start">
                  <Button
                    leftIcon={light('upload')}
                    variant="danger-outline"
                    className={'order-1 order-lg-3 mt-7'}
                    size="sm"
                    onClick={() => openModal('document-upload')}
                  >
                    Upload Document
                  </Button>
                </div>
              </div>
              <div className="d-flex flex-column px-12 py-10 w-100">
                <span className="fw-normal text-sub1 lh-xs">Mail</span>
                <div className="d-flex flex-column mt-7">
                  <span className="fw-light text-sub1 lh-xs">Regular Mail</span>
                  <span className="fw-light text-sub1 lh-xs">Interlink</span>
                  <span className="fw-light text-sub1 lh-xs">
                    Benefits Express
                  </span>
                  <span className="fw-light text-sub1 lh-xs">
                    P.O. Box 5241
                  </span>
                  <span className="fw-light text-sub1 lh-xs">
                    Cherry Hill, NJ 08034-5241
                  </span>
                </div>
                <div className="d-flex flex-column mt-7">
                  <span className="fw-light text-sub1 lh-xs">
                    Overnight Delivery
                  </span>
                  <span className="fw-light text-sub1 lh-xs">
                    Benefits Express Employee Service Center
                  </span>
                  <span className="fw-light text-sub1 lh-xs">
                    101 Woodcrest Road
                  </span>
                  <span className="fw-light text-sub1 lh-xs">
                    Cherry Hill, NJ 08003
                  </span>
                </div>
              </div>
            </section>
            <section className="mt-7">
              <span className="fw-normal text-sub1 lh-xs">Review</span>
            </section>
            <section className="d-flex flex-column mt-7">
              <div>
                <span className="fw-light text-sub1 lh-xs">
                  Once your completed paperwork has been received it will be
                  reviewed. If there are any problems with the paperwork you
                  will be notified...
                </span>
              </div>
              <div className="pt-7">
                <span className="fw-light text-sub1 lh-xs">
                  If approved you will receive a .... Also all status updates
                  will be available in the{' '}
                  <span className="fw-normal text-sub1 lh-xs">
                    Family Members
                  </span>{' '}
                  section of the profile page.
                </span>
              </div>
            </section>
          </div>
        </Container>
      ) : (
        <Successfull />
      )}
      <Col className="p-0 pt-5 pt-lg-0 col-lg-3">
        <div>
          <CustomSelect options={options} onChange={handleOnStateChange} />
        </div>
      </Col>
    </Container>
  );
};

export default CompletedPage;
